import { getDatabase, ref, set } from "firebase/database";
import { v4 as uuid } from 'uuid';
import { useProgramCategories } from "./useProgramCategories"

export const useAddToFirebase = () => {
    const { programCategories } = useProgramCategories('/AdminProgramsTreeMulti/Master')

    const addCompany = (companyName, adminEmail, adminName) => {
        let companyId = uuid()
        window.companyId = companyId
        const db = getDatabase();
        set(ref(db, 'Companies/' + companyId), {
            adminEmail: adminEmail,
            adminName: adminName,
            name: companyName,
            isMaster: false,
            id: companyId
        });
    }

    const addUser = (email, name) => {
        let userId = uuid()
        const db = getDatabase();
        set(ref(db, 'Users/' + email.replaceAll(".", "")), {
            email: email,
            name: name,
            companyid: window.companyId,
            usergroup: 'Administrator',
            id: userId
        });
    }

    const copyMasterAdminProgramToBranch = () => {
        let branch = window.companyId

        programCategories && programCategories.map(category => (
            category.adminPrograms && category.adminPrograms.map(adminProgram => (
                uploadFirebaseAdminProgram(branch, category.name, adminProgram)
            ))
        ))
    }

    function uploadFirebaseAdminProgram(branch, categoryName, adminProgram ) {
        const db = getDatabase();
        set(ref(db, 'AdminProgramsTreeMulti/' + branch + '/' + categoryName + '/' + adminProgram.programName), {...adminProgram.exercises});
       
    }

    return { addCompany, addUser, copyMasterAdminProgramToBranch }

}
